import { render, staticRenderFns } from "./BuymodalHeader.vue?vue&type=template&id=5321ad3b&"
import script from "./BuymodalHeader.vue?vue&type=script&lang=js&"
export * from "./BuymodalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports